/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,OverlayPanelModule,ButtonModule, TreeModule,InputTextModule,InputTextareaModule,CheckboxModule,CalendarModule} from 'primeng/primeng';
import {RouterModule} from "@angular/router";
import {HttpModule} from "@angular/http";
import { FormsModule } from '@angular/forms';
import {BrowserModule} from "@angular/platform-browser";
@Component({
  selector: 'holiday-management',
  templateUrl: 'holiday_management.html',
  styleUrls : ['holiday_management.css']
})
export class HolidayManagementComponent implements OnInit {
  kr : any;
  date8: Date;
  constructor() {
  }

  ngOnInit() {
    this.kr = {
      firstDayOfWeek: 0,
      dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: [ "일","월","화","수","목","금","토" ],
      monthNames: [ "January","February","March","April","May","June","July","August","September","October","November","December" ],
      monthNamesShort: [ "1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월" ]
    }
  }
}

@NgModule({
  imports: [DataTableModule,TabViewModule,PanelModule,OverlayPanelModule,ButtonModule, TreeModule,InputTextModule,InputTextareaModule,CheckboxModule,CalendarModule,RouterModule,HttpModule,FormsModule,BrowserModule],
  exports: [HolidayManagementComponent],
  declarations: [HolidayManagementComponent],
  providers: [],
})
export class HolidayManagementModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/policy/holiday_management.ts